export default "__VITE_ASSET__BUysRFH5__"